export const quickCostLimitations = [
  "Quick Costing provides directional estimates, not final supplier quotes",
  "Accuracy depends on completeness and quality of user inputs",
  "AI-generated results should be reviewed and may vary across runs",
  "Cost benchmarks, assumptions, and market data require periodic refresh",
  "Supplier-specific discounts, negotiations, contract terms, and regional nuances may not be fully captured",
  "Final results should be SME-reviewed before client-facing or commercial decisions",
];

export const QUICK_COST_LIMITATIONS_KEY = "hideQuickCostLimitationsPopup";
